// Feature keys (the bot's capability names) and which feature each kind of
// content belongs to. Shared by the API layer (what it may send) and the UI
// (what it may show) so both ask the same question. Which plan opens a
// feature is NOT here — it arrives with the account (`account.capabilities`).
import type { Notice, SignalType } from '@/types';

export const FEATURES = [
  'coin_news', 'market_summary', 'global_news', 'portfolio', 'orca_ai', 'signals',
  'macro_news', 'economic_calendar', 'weekly_forecast', 'price_alerts', 'twitter', 'youtube',
  'investment_ideas', 'send_news_now', 'whale_alerts', 'wall_street',
] as const;
export type Feature = (typeof FEATURES)[number];

/** a signal on the Signals timeline belongs to the feature that produced it */
export const SIGNAL_FEATURE: Record<SignalType, Feature> = {
  whale: 'whale_alerts', x: 'twitter', price: 'price_alerts', news: 'coin_news', yt: 'youtube', macro: 'macro_news', ai: 'signals',
};

/** a bell / pop-up notification belongs to the feature that sent it */
export const NOTICE_FEATURE: Record<Notice['kind'], Feature> = {
  price: 'price_alerts', whale: 'whale_alerts', digest: 'wall_street', calendar: 'economic_calendar', news: 'coin_news', x: 'twitter',
  payment: 'portfolio', forecast: 'weekly_forecast',
};

/** pages that ARE a feature: on a plan without it they show the feature's preview */
export const ROUTE_FEATURE: Partial<Record<string, Feature>> = {
  '/calendar': 'economic_calendar',
  '/wall-street': 'wall_street',
  '/social': 'twitter',
  '/alerts': 'price_alerts',
  '/whales': 'whale_alerts',
};

/** delivery rows in Settings → the feature behind them */
export const DELIVERY_FEATURE: Record<string, Feature> = {
  coin: 'coin_news', ov: 'market_summary', global: 'global_news', macro: 'macro_news', x: 'twitter', ws: 'wall_street',
  price: 'price_alerts', whale: 'whale_alerts', yt: 'youtube', ideas: 'investment_ideas', cal: 'economic_calendar',
};
